<div class="flex justify-between"><h6 class="tk-skolar-latin mb-1.5 text-base font-bold">{{label}}</h6><p class="text-sm font-thin" *ngIf="secondaryLabel">{{secondaryLabel}}</p></div>
<div class="w-full bg-white rounded border-gray-200 border-2 h-12 relative cursor-pointer items-center flex" (click)="fileInput.click()">
  <p *ngIf="file$ | async" class="px-2 m-0 text-base">{{(file$ | async).name}}</p>
  <mat-icon class="text-black absolute right-3 top-2.5 " svgIcon="eva-upload"></mat-icon>
</div>

<input #fileInput [hidden]="true" (change)="onFileSelected($event)" type="file" [accept]="accept" class="hidden" />
